import { Component, OnInit } from '@angular/core';
import { DATETIME_FORMAT } from 'src/app/core/constants/date';
import { SystemNotification } from 'src/app/core/models/system-notification-message';
import { AuthService } from 'src/app/core/services/auth.service';
import { SystemNotificationService } from 'src/app/core/services/system-notification.service';

@Component({
  selector: 'th-app-notification',
  templateUrl: './app-notification.component.html',
  styleUrls: ['./app-notification.component.scss']
})
export class AppNotificationComponent implements OnInit {
  currentNotifications: SystemNotification[] = [];
  protected readonly dateFormat = DATETIME_FORMAT;

  get isAnonymousUser(): boolean {
    return !this.authService.isAuthenticated();
  }

  constructor(
    private systemNotificationService: SystemNotificationService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.fetchSystemNotifications();
  }

  fetchSystemNotifications() {
    if (this.isAnonymousUser) {
      this.systemNotificationService.fetchCurrentNotifications().subscribe((data) => {
        this.currentNotifications = data || [];
      });
    }
  }
}
